import { cleanPhoneNumber } from '../../utils/phoneUtils';
import { closeQuickEstimateThankYou } from '../../redux/slice/quickEstimateSlice';
import { DEFAULT_PHONE_NUMBER } from '../../constants/phone';
import { LD_FLAGS } from '../../constants/launch-darkley';
import { resolveLeadRoutingPhone } from '../../utils/leadRouting';
import type { LeadRoutingConfig } from '../../types/lead-routing';
import { RootState, useAppDispatch, useAppSelector } from '../../redux/store';
import {
  BranchPhoneLink,
  CloseButton,
  CloseIcon,
  ContentWrapper,
  Modal,
  ModalContent,
  ThankYouMessageBox,
  ThankYouMessageText,
  Title,
} from './QuickEstimateModalStyle';

export default function QuickEstimateThankYouModal() {
  const dispatch = useAppDispatch();
  const thankYouConfig = useAppSelector(
    (state: RootState) => state.quickEstimate.thankYouConfig,
  );
  const branch = useAppSelector((state: RootState) => state.location.branch);
  const ldFlags = useAppSelector((state: RootState) => state.app?.ldFlags);

  const defaultBranchPhone = branch?.location?.location_phone ?? DEFAULT_PHONE_NUMBER;
  const branchPhone = resolveLeadRoutingPhone(
    ldFlags?.[LD_FLAGS.LEAD_ROUTING_CONFIG] as LeadRoutingConfig | undefined,
    branch?.location?.region?.region_id,
    defaultBranchPhone,
  );
  const cleanedBranchPhone = cleanPhoneNumber(branchPhone);

  if (!thankYouConfig) return null;

  const handleClose = () => {
    dispatch(closeQuickEstimateThankYou());
  };

  const title = `Get an estimate now - ${thankYouConfig.equipmentName}`;

  return (
    <Modal open={thankYouConfig.open} onClose={handleClose}>
      <ModalContent>
        <ContentWrapper>
          <CloseButton onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
          <Title>{title}</Title>
          <ThankYouMessageBox>
            <ThankYouMessageText>
              Thanks! A member of our team will reach out shortly. Or call{' '}
              <BranchPhoneLink href={`tel:${cleanedBranchPhone}`}>{branchPhone}</BranchPhoneLink>{' '}
              for immediate assistance.
            </ThankYouMessageText>
          </ThankYouMessageBox>
        </ContentWrapper>
      </ModalContent>
    </Modal>
  );
}
